.busyContainer {
  background-color: #1a1a1a;
  border: 1px solid #333;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--mantine-radius-xl);
  padding: var(--mantine-spacing-xl);
}

.busyText {
  text-align: center;
  white-space: pre-line;
}
